import { MdAdd, MdCheck, MdPeopleOutline } from 'react-icons/md';
import NewConversationResultMemberCard from 'components/NewConversationResultMemberCard';
import Modal from 'components/Modal';
import { ModalHeader, ModalBody, ModalTitle, ModalContent } from 'ui/modal';
import {
  TitleAndAction,
  ActionButton,
  Buttons,
  Button,
  ButtonReset,
} from 'ui';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { isEqual, orderBy } from 'lodash';
import { CardElement, CardElementContent } from '@tymate/sergic';

const DistributionListContactPickerModal = ({
  onRequestClose,
  distributionList,
  onAddEntities,
}) => {
  const { t } = useTranslation('newConversation');
  const [selectedMembers, setSelectedMembers] = useState([]);

  const handleAddAllSelectedListMembers = () => {
    setSelectedMembers(distributionList.users);
  };

  const handleToggleSelectedMember = targetId => {
    if (selectedMembers.indexOf(targetId) > -1) {
      setSelectedMembers(selectedMembers.filter(id => id !== targetId));
      return;
    }

    setSelectedMembers([...selectedMembers, targetId]);
  };

  const handleSubmit = () => {
    if (isAddingWholeList) {
      onAddEntities([{ entity: distributionList, type: 'DISTRIBUTION_LIST' }]);
    } else {
      onAddEntities(
        selectedMembers.map(member => ({ entity: member, type: 'MEMBER' })),
      );
    }

    onRequestClose();
  };

  const isAddingWholeList =
    selectedMembers.length > 0 &&
    isEqual(
      orderBy((distributionList?.users || []).map(({ id }) => id)),
      orderBy(selectedMembers).map(({ id }) => id),
    );

  return (
    <Modal isOpen onRequestClose={onRequestClose}>
      <ModalContent>
        <ModalHeader>
          <ModalTitle small>{t('diffusion')} Sergic</ModalTitle>
        </ModalHeader>

        <ModalBody>
          <div style={{ marginLeft: 8, marginBottom: 16 }}>
            {!isAddingWholeList && (
              <CardElement>
                <CardElementContent
                  as={ButtonReset}
                  onClick={handleAddAllSelectedListMembers}
                  style={{ padding: 8, paddingTop: 8, paddingBottom: 0 }}
                >
                  <TitleAndAction style={{ marginBottom: 8 }}>
                    <span
                      style={{
                        fontWeight: 500,
                        display: 'flex',
                        alignItems: 'center',
                        flex: 1,
                      }}
                    >
                      <MdPeopleOutline
                        size={24}
                        style={{ marginLeft: 4, marginRight: 8 }}
                      />
                      {t('selectAll')}
                    </span>

                    <ActionButton as="span" style={{ marginTop: 8 }}>
                      <MdAdd />
                    </ActionButton>
                  </TitleAndAction>
                </CardElementContent>
              </CardElement>
            )}

            {(distributionList?.users || []).map(user => {
              return (
                <TitleAndAction
                  hasTopSeparation
                  style={{
                    paddingLeft: 8,
                    paddingRight: 8,
                    marginLeft: 0,
                    width: '100%',
                  }}
                  as={ButtonReset}
                  onClick={() => handleToggleSelectedMember(user)}
                >
                  <NewConversationResultMemberCard {...user} />

                  <ActionButton>
                    {selectedMembers.map(({ id }) => id).indexOf(user.id) >
                    -1 ? (
                      <MdCheck />
                    ) : (
                      <MdAdd />
                    )}
                  </ActionButton>
                </TitleAndAction>
              );
            })}
          </div>

          <Buttons right>
            <Button onClick={onRequestClose}>{t('misc:cancel')}</Button>
            <Button isPrimary onClick={handleSubmit}>
              {t('misc:add')}
            </Button>
          </Buttons>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default DistributionListContactPickerModal;
